module.exports = __webpack_public_path__ + "img/culture1.a5eab164.jpg";